export default class ConditionalStyler {
    /**
     * 
     * @param styler 
     * @param style 
     * @param feature 
     * @param layerViewInfo 
     * 
     * @returns 
     */
    getStyle(styler, style, feature, layerViewInfo) {
        let ret = style;
        const conditionalStyles = styler.conditionalStyles;
        for(let c = conditionalStyles.length; c-- > 0;){
            const conditionalStyle = conditionalStyles[c];

            if (es.util.criteria.matchFeature(conditionalStyle.attrValueCriteria, feature)) {
                // Merge conditionalStyle.style into styler.defaultStyle so we inherit default vals
                ret = es.util.object.deepCopy(conditionalStyle.style);

                if (ret.$type == "SymbolStyle" || ret.$type == "SymbolAndPolygonStyle") {
                    const styleSymbolStyle = (style.$type == "SymbolAndPolygonStyle" ? style.symbolStyle : style);
                    const retSymbolStyle = (ret.$type == "SymbolAndPolygonStyle" ? ret.symbolStyle : ret);

                    if (styleSymbolStyle.$type == "SymbolStyle"){
                        retSymbolStyle.text = styleSymbolStyle.text;
                    }
                }

                break;
            }
        }

        return ret;
    }

    // getDefaultStyle is not implemented... Only base stylers should have it (SingleStyler and ColorPerFeatureStyler)

    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    getPaddingPx(styler) {
        const ret = [0, 0];
        const conditionalStyles = styler.conditionalStyles;
        for (let c = conditionalStyles.length; c-- > 0; ) {
            const style = conditionalStyles[c].style;

            const paddingPx = es.util.style.types[style.$type].getPaddingPx(style);
            ret[0] = Math.max(ret[0], paddingPx[0]);
            ret[1] = Math.max(ret[1], paddingPx[1]);
        }

        return ret;
    }

    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    hasDirect(styler) {
        const conditionalStyles = styler.conditionalStyles;
        for (let c = conditionalStyles.length; c-- > 0; ) {
            const style = conditionalStyles[c].style;
            
            if (es.util.style.types[style.$type].hasDirect(style)) {
                return true;
            }
        }

        return false;
    }

    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    hasOverlays(styler) {
        const conditionalStyles = styler.conditionalStyles;
        for (let c = conditionalStyles.length; c-- > 0;) {
            const style = conditionalStyles[c].style;

            if (es.util.style.types[style.$type].hasOverlays(style)) {
                return true;
            }
        }

        return false;
    }
    
    /**
     * 
     * @param styler 
     * 
     * @returns 
     */
    getHideFeaturesCriteria(styler) {
        return null;
    }
}
